import { useState, useEffect } from 'react'
import { Form as FinalForm, Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { styled, Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { Grid, Typography, Tooltip, Button, Link, Breadcrumbs } from '@mui/material'
import Dialog from '../../control/Dialog'
import Textbox from '../../control/Textbox'
import CheckboxInput from '../input/CheckboxFormInput'
import useUserGroup, { Form, validate, UserPermissionType } from '../../hooks/backoffice/useUserGroup'
import BackIcon from '@mui/icons-material/ArrowBackIosNewRounded'
import { useSelector } from 'react-redux'
import { RootStateType } from '../../redux/reducer/rootReducer'

type ManageUserGroupFormProps = {
    type: 'add' | 'edit'
}

const ManageUserGroupForm = (props: ManageUserGroupFormProps) => {
    const { type } = props
    const {
        permissionList,
        alertMessageError,
        openDialogError,
        alertMessageOk,
        openDialogBack,
        openDialogSave,
        openDialogOk,
        onClickConfirmSave,
        onClickCancelSave,
        onClickBack,
        onClickForceBack,
        onClickCancelBack,
        onClickConfirmBack,
        onClickOk,
        onSubmitForm,
        callServiceGetById,
    } = useUserGroup()
    const { t } = useTranslation()
    const classes = useStyles()

    const validates = (values: Form) => {
        const validation = validate(values, t) || {}
        return validation
    }

    const [groupId, setGroupId] = useState<number>(0)
    const [titleName, setTitleName] = useState<string>()
    const [initialValues, setInitialValues] = useState<Form>({
        userGroupName: '',
        description: '',
        userPermission: [],
    })

    const { isLoggedIn } = useSelector(({ profile }: RootStateType) => profile)

    useEffect(() => {
        if (type === 'add') {
            setTitleName(`${t('BUTTON.ADD')}${t('LABEL.BACKOFFICE.USER_GROUP.TITLE')}`)
        }
        if (type === 'edit') {
            setTitleName(`${t('BUTTON.EDIT')}${t('LABEL.BACKOFFICE.USER_GROUP.TITLE')}`)
        }
    }, [])

    useEffect(() => {
        if (type === 'edit' && permissionList.length && isLoggedIn) {
            const url = globalThis.location.href
            const splitUrl = url.split('/')
            const id = parseInt(splitUrl[splitUrl.length - 2])
            if (id) {
                setGroupId(id)
                callServiceGetInitial(id, permissionList)
            }
        }
    }, [isLoggedIn])

    useEffect(() => {
        if (type === 'edit' && permissionList.length && isLoggedIn) {
            const url = globalThis.location.href
            const splitUrl = url.split('/')
            const id = parseInt(splitUrl[splitUrl.length - 2])
            if (id) {
                setGroupId(id)
                callServiceGetInitial(id, permissionList)
            }
        }
    }, [permissionList, isLoggedIn])

    const callServiceGetInitial = async (id: number, permissionList: UserPermissionType[]) => {
        const { result } = await callServiceGetById(id)

        if (result?.data) {
            const dataPermission = permissionList.map((item) => {
                return result?.data.permission.includes(item.id) ? true : false
            })

            setInitialValues({
                userGroupName: result?.data.name,
                description: result?.data.description,
                userPermission: dataPermission,
            })
        }
    }

    return (
        <>
            <FinalForm onSubmit={onSubmitForm} validate={validates} initialValues={initialValues}>
                {({ handleSubmit, values, dirty }) => (
                    <form onSubmit={handleSubmit}>
                        <StyledDivHeader>
                            <Tooltip title={`กลับไปหน้า${t('MENU.USER_GROUP_MANAGEMENT')}`} placement="top">
                                <Button
                                    onClick={() => {
                                        onClickBack(dirty)
                                    }}
                                    className={classes.backButton}
                                >
                                    <IconBack />
                                </Button>
                            </Tooltip>
                            <StyledTypoHeader variant="h6">{titleName}</StyledTypoHeader>
                        </StyledDivHeader>
                        {/* <Breadcrumbs aria-label="breadcrumb" className={classes.breadcrumb}>
                <StyledLinkBreadcrumb underline="hover" onClick={onClickForceBack}>
                    {t('MENU.USER_GROUP_MANAGEMENT')}
                </StyledLinkBreadcrumb>
                <Typography color="text.primary" style={{ fontWeight: 'bold' }}>
                    {titleName}
                </Typography>
            </Breadcrumbs> */}
                        <StyledDivForm>
                            <Grid container spacing={2} className={classes.container}>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        name="userGroupName"
                                        label={`${t('LABEL.BACKOFFICE.USER_GROUP.NAME')}${t(
                                            'LABEL.BACKOFFICE.USER_GROUP.TITLE',
                                        )}`}
                                        placeholder={`${t('LABEL.BACKOFFICE.USER_GROUP.NAME')}${t(
                                            'LABEL.BACKOFFICE.USER_GROUP.TITLE',
                                        )}`}
                                        component={Textbox}
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        name="description"
                                        label={t('LABEL.BACKOFFICE.USER_GROUP.DESCRIPTION')}
                                        placeholder={t('LABEL.BACKOFFICE.USER_GROUP.DESCRIPTION')}
                                        component={Textbox}
                                        fullWidth
                                    />
                                </Grid>
                                {permissionList.length > 0 && (
                                    <Grid item xs={12}>
                                        <StyledTypoPermission>
                                            {t('LABEL.BACKOFFICE.USER_GROUP.USER_PERMISSION')}
                                        </StyledTypoPermission>
                                        {permissionList.map((item, index: number) => (
                                            <Field
                                                key={index}
                                                name={`userPermission.${index}`}
                                                label={item.name}
                                                component={CheckboxInput}
                                                type={'checkbox'}
                                                labelPlacement="end"
                                                overrideClass={{
                                                    root: classes.checkbox,
                                                    checked: classes.checkboxChecked,
                                                }}
                                                // required
                                            />
                                        ))}
                                    </Grid>
                                )}
                                <Grid item xs={12} className={classes.divButtonGroup}>
                                    <div className={classes.divButton}>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            onClick={() => {
                                                onClickBack?.(dirty)
                                            }}
                                            classes={{ root: classes.button }}
                                        >
                                            {t('BUTTON.CANCEL')}
                                        </Button>
                                    </div>
                                    <div className={classes.divButton}>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            classes={{ root: classes.button }}
                                        >
                                            {t('BUTTON.SAVE')}
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </StyledDivForm>
                    </form>
                )}
            </FinalForm>
            <Dialog
                type="confirm"
                title={t('ALERT.TITLE.NOTIFY')}
                content={t('ALERT.CONTENT.DISCARD_CHANGE')}
                isOpen={openDialogBack ? true : false}
                onClickCancel={onClickConfirmBack}
                onClickConfirm={onClickCancelBack}
                labelButtonCancel={t('BUTTON.LEAVE')}
                labelButtonConfirm={t('BUTTON.STAY')}
                disableClickBackdrop
                hideCloseButton
            />
            <Dialog
                type="confirm"
                title={t('ALERT.TITLE.NOTIFY')}
                content={'ยืนยันบันทึกข้อมูล'}
                isOpen={openDialogSave}
                onClickConfirm={() => {
                    onClickConfirmSave(type, groupId)
                }}
                onClickCancel={onClickCancelSave}
                labelButtonCancel={t('BUTTON.CANCEL')}
                labelButtonConfirm={t('BUTTON.CONFIRM')}
                disableClickBackdrop
                hideCloseButton
            />
            <Dialog
                type="ok"
                title={t('ALERT.TITLE.NOTIFY')}
                content={alertMessageOk}
                isOpen={openDialogOk}
                onClickOk={onClickOk}
                labelButtonOk={t('BUTTON.OK')}
                disableClickBackdrop
                hideCloseButton
            />
            <Dialog
                type="ok"
                severity="error"
                title={t('ALERT.TITLE.ERROR')}
                content={alertMessageError}
                isOpen={openDialogError}
                onClickOk={onClickOk}
                labelButtonOk={t('BUTTON.OK')}
                disableClickBackdrop
                hideCloseButton
            />
        </>
    )
}

export default ManageUserGroupForm

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    breadcrumb: {
        color: `${theme.palette.getContrastText('black')} !important`,
    },
    divButtonGroup: {
        display: 'flex',
        justifyContent: 'end',
        paddingBottom: '15px',
    },
    divButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginLeft: theme.spacing(1),
    },
    button: {
        width: '125px',
        minHeight: '37px',
        fontSize: '14px !important',
    },
    backButton: {
        padding: '0px !important',
        minWidth: '25px !important',
        minHeight: '25px !important',
        marginRight: '10px !important',
        color: `transparent !important`,
    },
    checkbox: {
        color: `${theme.palette.primary.dark} !important`,
        padding: '5px 10px !important',
    },
    checkboxChecked: {
        color: `${theme.palette.primary.dark} !important`,
        padding: '5px 10px !important',
    },
}))

const StyledDivHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    paddingBottom: '15px',
}))

const StyledTypoHeader = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
}))

const StyledDivForm = styled('div')(({ theme }) => ({
    width: '100%',
    padding: '15px 30px',
    marginBottom: '15px',
    borderRadius: '5px',
    backgroundColor: theme.palette.text.secondary,
    boxShadow: theme.palette.getContrastText('shadow-bottom-gray'),
}))

const StyledTypoPermission = styled(Typography)(({ theme }) => ({
    paddingTop: '5px',
}))

const StyledLinkBreadcrumb = styled(Link)(({ theme }) => ({
    cursor: 'pointer',
}))

const IconBack = styled(BackIcon)(({ theme }) => ({
    color: theme.palette.primary.main,
}))
